import type { BankDetails, User } from '@/types';
import api from './api';

export const userService = {
  async updateProfilePhoto(profilePhoto: string): Promise<User> {
    const response = await api.patch<User>('/users/me', {
      profilePhoto,
    });
    return response.data;
  },

  async updateBankDetails(bankDetails: BankDetails): Promise<User> {
    const response = await api.patch<User>('/users/me', {
      bankDetails,
    });
    return response.data;
  },
};

export default userService;
